import * as d3 from 'd3';

export const trigonoScale = d3.scale.linear()
    .domain([0, 2 * Math.PI])
    .range([Math.PI / 2, 5 * Math.PI / 2]);
